import { IBatchOptions, IBatchPromiseElement } from '@kurtosys/types/api/common/index.js';

export async function batchExecutePromises(
	batchPromiseElements: IBatchPromiseElement[],
	passedOptions: IBatchOptions = {},
): Promise<void> {
	const options = Object.assign({}, { maxBatchSize: 100 }, passedOptions);
	const elements: IBatchPromiseElement[] = [].concat(batchPromiseElements);
	const { maxBatchSize } = options;

	while (elements.length > 0) {
		const currentBatchSize = Math.min(elements.length, maxBatchSize);
		const currentBatch = elements.splice(0, currentBatchSize);
		await runBatch(currentBatch);
	}
}

async function runBatch(batch: IBatchPromiseElement[] = []): Promise<void> {
	const responses = await runBatchPromiseFunctions(batch);
	await runBatchResponseFunctions(batch, responses);
}

async function runBatchPromiseFunctions(batch: IBatchPromiseElement[] = []): Promise<any[]> {
	const promises = batch.map((element) => {
		return element.promiseFunc();
	});
	const responses = await Promise.all(
		promises.map((p) => {
			return p.catch ? p.catch((e) => e) : p;
		}),
	);
	return responses;
}

async function runBatchResponseFunctions(batch: IBatchPromiseElement[] = [], responses: any[]): Promise<any[]> {
	const promises = batch.reduce((acc, element, index) => {
		const response = responses[index];
		if (!(response instanceof Error)) {
			acc.push(element.responseFunc(response, element.identifier));
		}
		return acc;
	}, []);
	return Promise.all(promises);
}
